import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-steps-item",
    styleUrl: "steps-item.scss",
    shadow: true
})
export class StepItem {
    /** indictates if step is active */
    @Prop() readonly current: boolean = false;

    /** indicates if step is done */
    @Prop() readonly done: boolean = false;

    /** number to be shown in the circle */
    @Prop() readonly number: number = 0;

    render() {
        return (
            <Host done={this.done} active={this.current} aria-current={this.current ? "true" : undefined}>
                {this.done ? <ux-icon aria-hidden="true" name="checkmark" weight="bold"></ux-icon> : this.number}
                <p>
                    <slot />
                </p>
            </Host>
        );
    }
}
